var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "nti-checkout-cart" }, [
    _c(
      "article",
      { staticClass: "nti-checkout-line__item__mini-cart-header" },
      [
        _c("section", { staticClass: "nti-checkout-line__item__wrapper" }, [
          _c("div", {
            staticClass: "nti-checkout-line__item__image-container__void",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "nti-checkout-line__item__labels" }, [
            _c(
              "span",
              { staticClass: "nti-webshop-checkout__mini-cart__label" },
              [_vm._v(_vm._s(_vm.verifyLabel("itemLabel")))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "nti-checkout-line__item__info-container" },
          [
            _c(
              "div",
              {
                staticClass:
                  "nti-checkout-line__item__amount nti-checkout-line__item__info-block",
                class: {
                  "nti-checkout-line__item__info-block--scroll-margin-middle":
                    !_vm.scrollbarMargin,
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "nti-webshop-checkout__mini-cart__label" },
                  [_vm._v(_vm._s(_vm.verifyLabel("quantityLabel")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "nti-checkout-line__item__info-block nti-checkout-line__item__info-block--price",
                class: {
                  "nti-checkout-line__item__info-block--scroll-margin-nav":
                    _vm.scrollbarMargin,
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "nti-webshop-checkout__mini-cart__label" },
                  [_vm._v(_vm._s(_vm.verifyLabel("priceLabel")))]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "nti-checkout-cart__container nti-checkout-cart__container--cart-line",
      },
      [
        _vm._l(_vm.cartItems, function (data) {
          return [
            _c("CartCheckoutLine", {
              key: data.code,
              attrs: { lineData: data, itemCountInCart: _vm.itemCountInCart },
            }),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "nti-checkout-line__total__wrapper" }, [
      _c("section", { staticClass: "nti-checkout-line__total" }, [
        _c("div", { staticClass: "nti-checkout-line__total__container" }, [
          _c("div", { staticClass: "nti-checkout-line__total__labels" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(" " + _vm._s(_vm.cartTotalExclVatLabel) + " "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nti-checkout-line__total__price" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(_vm._s(_vm.cartTotalExclVat)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasDiscount
        ? _c("section", { staticClass: "nti-checkout-line__total" }, [
            _c("div", { staticClass: "nti-checkout-line__total__container" }, [
              _c("div", { staticClass: "nti-checkout-line__total__labels" }, [
                _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.discountLabel) +
                      " - " +
                      _vm._s(_vm.couponCode) +
                      " "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nti-checkout-line__total__price" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "nti-checkout-line__total__sum nti-checkout-line__total__sum--discount",
                  },
                  [_vm._v("-" + _vm._s(_vm.discount))]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "nti-checkout-line__total" }, [
        _c("div", { staticClass: "nti-checkout-line__total__container" }, [
          _c("div", { staticClass: "nti-checkout-line__total__labels" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(_vm._s(_vm.handlingFeeLabel)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nti-checkout-line__total__price" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(_vm._s(_vm.handlingFee)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "nti-checkout-line__total" }, [
        _c("div", { staticClass: "nti-checkout-line__total__container" }, [
          _c("div", { staticClass: "nti-checkout-line__total__labels" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(" " + _vm._s(_vm.totalExVatLabel) + " "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nti-checkout-line__total__price" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(_vm._s(_vm.totalExVat)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "nti-checkout-line__total" }, [
        _c("div", { staticClass: "nti-checkout-line__total__container" }, [
          _c("div", { staticClass: "nti-checkout-line__total__labels" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(" " + _vm._s(_vm.vatLabel) + " "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nti-checkout-line__total__price" }, [
            _c("p", { staticClass: "nti-checkout-line__total__sum" }, [
              _vm._v(_vm._s(_vm.vat)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "nti-checkout-line__total nti-checkout-line__total--vat",
        },
        [
          _c("div", { staticClass: "nti-checkout-line__total__container" }, [
            _c("div", { staticClass: "nti-checkout-line__total__labels" }, [
              _c(
                "p",
                {
                  staticClass:
                    "nti-checkout-line__total__sum nti-checkout-line__total__sum--vat",
                },
                [_vm._v(" " + _vm._s(_vm.totalIncVatLabel) + " ")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "nti-checkout-line__total__price" }, [
              _c(
                "p",
                {
                  staticClass:
                    "nti-checkout-line__total__sum nti-checkout-line__total__sum--vat",
                },
                [_vm._v(_vm._s(_vm.totalIncVat))]
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }